import { render, staticRenderFns } from "./productSort.vue?vue&type=template&id=b63f9bd0&scoped=true"
import script from "./productSort.vue?vue&type=script&lang=js"
export * from "./productSort.vue?vue&type=script&lang=js"
import style0 from "./productSort.vue?vue&type=style&index=0&id=b63f9bd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63f9bd0",
  null
  
)

export default component.exports